<template><div><h1>VUX V2.3.3 发布日志</h1>
<h2><a href="/zh-CN/components/badge.html">Badge</a></h2>
<ul><li>[feature] 支持没有指定文字时为 红点 样式</li>
</ul>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持 slot:title</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] 支持 slot:popup-header</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[enhance] 默认 max-height 设为 100%，避免不设置高度时内容过长无法滚动</li>
<li>[feature] 支持 prop:max-height</li>
<li>[fix] 禁止遮罩层在手机上滚动 #1475 @xiaobinhong1</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[enhance] 设置 placeholder 颜色. #1465</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.3 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.3-234.vue?63fef2fc